module.exports = __webpack_public_path__ + "img/step2-t.b6f47dcc.png";